import { render } from "./MediaModal.vue?vue&type=template&id=fea9e880"
import script from "./MediaModal.vue?vue&type=script&lang=ts"
export * from "./MediaModal.vue?vue&type=script&lang=ts"

import "./MediaModal.vue?vue&type=style&index=0&id=fea9e880&lang=scss"
script.render = render

export default script